<template>
  <div class="transition-all">
    <div
      :class="
        'sidebar transition-all shadow-lg ' +
          (readingExperience.dict ? 'sidebar-show' : 'sidebar-hide')
      "
    >
      <div class="d-flex justify-content-center flex-column p-3">
        <div class="row d-flex align-items-center m-2 mt-4">
          <div class="col-md-2">
            <button
              class="btn br-button-primary text-white shadow-lg border-radius-2 d-flex align-items-center justify-content-center"
              @click="hide"
            >
              <i class="fas fa-chevron-left fa-2x"></i>
            </button>
          </div>
          <div class="col-md-8 mx-3">
            <h2 class="text-center">Diccionario</h2>
          </div>
        </div>
        <div class="m-2 mt-3 px-2">
          <BrSearchInput></BrSearchInput>
        </div>
        <div
          class="sidebar-panel"
          v-if="readingExperience.dictionary_data.length > 0"
        >
          <BrDictionaryItem
            v-for="(word, index) of readingExperience.dictionary_data"
            :key="index"
            :word_data="word"
          ></BrDictionaryItem>
        </div>
        <div class="sidebar-panel" v-else>
          <h3 class="mx-2 text-center">No se hay resultados para mostrar.</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import BrDictionaryItem from "./BrDictionaryItem";
import BrSearchInput from "./BrSearchInput";

export default {
  name: "br-dictionary-content",
  components: {
    BrDictionaryItem,
    BrSearchInput,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["readingExperience"]),
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["showDict"]),
    hide() {
      this.showDict();
    },
  },
};
</script>
